import { ColumnFiltersState, SortingState } from '@tanstack/react-table';

import {
  FetchRoutingsSort,
  FetchRoutingsSortCriteria,
  GetRoutingsBody,
  SortTypeEnum,
} from '../../../Services/API';

export const formatFilters = (
  columnFilters: ColumnFiltersState
): Pick<
  GetRoutingsBody,
  'qualifications' | 'sirets' | 'clientNames' | 'brandCodes' | 'agencyIds' | 'services'
> => {
  const filters: Pick<
    GetRoutingsBody,
    'qualifications' | 'sirets' | 'clientNames' | 'brandCodes' | 'agencyIds' | 'services'
  > = {};

  for (const column of columnFilters as {
    id: FetchRoutingsSortCriteria;
    value: string[];
  }[]) {
    switch (column.id) {
      case FetchRoutingsSortCriteria['routing.qualification']: {
        filters.qualifications = column.value;
        break;
      }
      case FetchRoutingsSortCriteria['routing.clientName']: {
        filters.clientNames = column.value;
        break;
      }
      case FetchRoutingsSortCriteria['routing.brandCode']: {
        filters.brandCodes = column.value;
        break;
      }
      case FetchRoutingsSortCriteria['routing.siret']: {
        filters.sirets = column.value;
        break;
      }
      case FetchRoutingsSortCriteria['agency.id']: {
        filters.agencyIds = column.value;
        break;
      }
      case FetchRoutingsSortCriteria['routing.service']: {
        filters.services = column.value;
        break;
      }
    }
  }

  return filters;
};

export const formatSorting = (state: SortingState): FetchRoutingsSort | undefined => {
  if (!state.length) return undefined;
  return {
    sortCriteria: state[0].id as FetchRoutingsSortCriteria,
    sortType: state[0].desc ? SortTypeEnum.DESC : SortTypeEnum.ASC,
  };
};
